export default __webpack_public_path__ + "static/media/bgHeader.c0c4118d.webp";